import React from "react";
import Grid from "@material-ui/core/Grid";
import { Box, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useSearchQuery } from "../common/use-searchQuery";
import { useSearch } from "../searchServices";
import { abbreviate } from "../../util/numberFormat";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 185,
    height: "100%",
    width: "100%",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  count: {
    marginRight: theme.spacing(1),
  },

  h1: {
    fontSize: "4.0rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  h4: {
    fontSize: "1.8rem",
    lineHeight: "2.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },

  body2: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontStyle: "italic",
  },
}));

const initialSearchState = {
  appliedQuery: [],
  appliedFacets: [
    {
      name: "type",
      queryParam: "_type",
      terms: [
        {
          code: "CONTENT",
        },
      ],
    },
  ],
  orderBy: "recordDate",
  orderDirection: "desc",
  otherParams: [],
  appliedPublicationYearGroups: [],
  page: 0,
  titleOnly: false,
  moduleOnly: false,
  limit: 1,
  noFacets: true,
};

const ItemCountCard = () => {
  const classes = useStyles();
  //-- Handle Search state
  const { state } = useSearchQuery(initialSearchState);

  const searchResults = useSearch(state);

  return (
    <Card classes={{ root: classes.root }}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            Items
          </Typography>
        </Grid>
      </Grid>

      {searchResults.isSuccess ? (
        <Box
          mt={1}
          height={100}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography
            variant="h1"
            component="span"
            classes={{ root: classes.count, h1: classes.h1 }}
          >
            {abbreviate(searchResults.data.totalCount, 2)}
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            Loading...
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default ItemCountCard;
